import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuth } from "../../context/AuthContext";

import AuthLayout from "./components/AuthLayout";
import AuthSidebar from "./components/AuthSidebar";
import LoginForm from "./components/LoginForm";

const Auth: React.FC = () => {
  const [isSignUp, setIsSignUp] = useState(false);
   const [isVisible, setIsVisible] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  
  useEffect(() => {
  const token = new URLSearchParams(location.search).get("token");
  setIsSignUp(!!token);
}, [location.search]);

 

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 80);
    return () => clearTimeout(timer);
  }, []);

  const switchTo = (value: boolean) => {
    setIsSignUp(value);
  };

  return (
    <AuthLayout isVisible={isVisible}>
      <ToastContainer position="top-right" />

      <div className="bg-white rounded-2xl border border-slate-100 shadow-[0_8px_40px_rgba(0,0,0,0.08)] overflow-hidden flex min-h-[520px]">
        <AuthSidebar isSignUp={isSignUp} switchTo={switchTo} />

        <div className="flex-1 flex flex-col justify-center px-6 sm:px-12 py-10">
          <div className="h-0.5 w-12 bg-[#0F52BA] rounded-full mb-8" />

          <h1 className="text-xl font-bold text-slate-800 mb-1">
            {isSignUp ? "Créer un compte" : "Connexion"}
          </h1>

          <p className="text-sm text-slate-400 mb-7">
            {isSignUp
              ? "Renseignez vos informations pour finaliser votre inscription."
              : "Entrez vos identifiants pour accéder à votre espace."}
          </p>

          {!isSignUp ? (
            <LoginForm login={login} navigate={navigate} />
          ) : (
            <div className="text-sm text-slate-500">
               Formulaire d'inscription à implémenter ici.
            </div>
          )}
        </div>
      </div>

      <p className="text-center text-[11px] text-slate-400 mt-4">
        © {new Date().getFullYear()} Metal 2000 · Tous droits réservés
      </p>
    </AuthLayout>
  );
};

export default Auth;